import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { dynamicAuthGuard } from './core/guards/dynamic-auth.guard';
import { catContestsResolver } from './how-do-i-win/resolvers/cat-contests.resolver';

export const routes: Routes = [
  { path: 'login/callback', component: OktaCallbackComponent },
  {
    path: '',
    loadChildren: () => import('./auth/pages/auth.routes'),
    data: { bodyClass: 'back-parallax-1' },
  },
  {
    path: 'home',
    loadChildren: () => import('./home/pages/home.routes'),
    title: 'Inicio',
    data: { isPrincipalMenu: true, class: 'inicio', image: '05.png' },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'rewards',
    loadChildren: () => import('./rewards/pages/rewards.routes'),
    title: 'Premios',
    data: { isPrincipalMenu: true, class: 'premios', image: '03.png' },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'social',
    loadChildren: () => import('./social/pages/social.routes'),
    title: 'Red social',
    data: {
      bodyClass: 'overflow-x-h',
      isPrincipalMenu: true,
      class: 'red',
      image: '01.png',
    },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'how-do-i-win',
    loadChildren: () => import('./how-do-i-win/pages/how-do-i-win.routes'),
    title: 'Concursos',
    data: {
      bodyClass: 'overflow-x-h',
      isPrincipalMenu: true,
      class: 'concursos',
      image: '08.png',
    },
    canActivate: [dynamicAuthGuard],
    resolve: {
      catContests: catContestsResolver,
    },
  },
  {
    path: 'achievements',
    loadChildren: () => import('./achievements/pages/achievements.routes'),
    title: 'Mis reconocimientos',
    data: { isPrincipalMenu: true, class: 'reconocimientos', image: '04.png' },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'my-orders',
    loadChildren: () => import('./my-orders/pages/my-orders.routes'),
    title: 'Mis pedidos',
    data: { isPrincipalMenu: true, class: 'pedidos', image: '06.png' },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'communications',
    loadChildren: () => import('./announcements/pages/announcements.routes'),
    title: 'Comunicaciones e iniciativas',
    data: { isPrincipalMenu: true, class: 'comunicacion', image: '09.png' },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'help',
    loadChildren: () => import('./help/pages/help.routes'),
    title: 'Preguntas frecuentes',
    data: { isPrincipalMenu: true, class: 'ayuda', image: '07.png' },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'my-points',
    loadChildren: () => import('./my-points/pages/my-points.routes'),
    title: 'Mis puntos',
    data: { bodyClass: 'overflow-x-h' },
    canActivate: [dynamicAuthGuard],
    resolve: {
      catContests: catContestsResolver,
    },
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/pages/profile.routes'),
    title: 'Perfil',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/pages/cart.routes'),
    title: 'Carrito',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'wishlist',
    loadChildren: () => import('./wishlist/pages/wishlist.routes'),
    title: 'Lista de deseos',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'base',
    loadComponent: () => import('./help/pages/base-page/base-page.component'),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./help/pages/privacy-page/privacy-page.component'),
  },
    {
    path: 'support',
    loadChildren: () =>
      import('./support/support.routes'),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
